import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { OfferSection } from '../components/OfferSection';
import { QualificationSection } from '../components/QualificationSection';
import { CTASection } from '../components/CTASection';
import { TermsModal } from '../components/TermsModal';
import { PrivacyModal } from '../components/PrivacyModal';
export function LandingPage() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <main className="min-h-screen bg-[#0a0a0a] text-zinc-100 selection:bg-[#d4a574] selection:text-black" data-id="element-215">
      <Hero data-id="element-216" />
      <PainSection data-id="element-217" />
      <ProblemSection data-id="element-218" />
      <MechanismSection data-id="element-219" />
      <OfferSection data-id="element-220" />
      <QualificationSection data-id="element-221" />
      <CTASection data-id="element-222" />

      <footer className="py-6 px-4 text-center text-zinc-600 text-xs border-t border-zinc-900 bg-[#0a0a0a]" data-id="element-223">
        <div className="space-y-2" data-id="element-224">
          <p className="leading-[1.3]" data-id="element-225">
            &copy; {new Date().getFullYear()} Conexión Instantánea. Todos los
            derechos reservados.
          </p>

          <div className="flex flex-wrap justify-center gap-3 text-xs" data-id="element-226">
            <button onClick={() => setIsTermsOpen(true)} className="hover:text-[#d4a574] transition-colors underline" data-id="element-227">
              Términos y Condiciones
            </button>
            <span className="text-zinc-800" data-id="element-228">|</span>
            <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-[#d4a574] transition-colors underline" data-id="element-229">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-230" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-231" />
    </main>;
}